export const http_post = (http_client, path, params, action_success, action_fail, callback) => {
    http_client.post(path, params)
        .then(function (response) {
            callback({'type' : action_success, 'data' : response.data});
        })
        .catch(function (error) {
            callback({'type' : action_fail, 'data' : error.response && error.response.data ? error.response.data : null});
        });
}